export const isValidPhone = phone => {
  return String(phone)
    .toLocaleLowerCase()
    .match(/^\([1-9]{2}\) [0-9]\d{4}-\d{4}$/);
};
